import * as AWS from "aws-sdk";
import Http from "./Http";
import moment from "moment";
import { Loading } from 'element-ui';
import LogController from "./logger/LogController";

// class S3Config {
//   static accessKeyId="n1BrY2bwTnzN5h9Hpwgj"
//   static secretAccessKey="vOrth4LfUjBZ2DQfkmVIKx5hPAhn2ePNq7L1ypuu"
//   static endpoint="https://gd4oss.ctyunxs.cn"
// }

var S3Config=null;

export default class ObjectStorage {
  accessKeyId=null;
  secretAccessKey=null;
  endpoint=null;

  credentials= null
  s3Client= null
  bucket=null
  key=null

  /**
   *
   * @param ossConfig
   */
  constructor(ossConfig) {
    const that=this;

    that.accessKeyId=ossConfig.AccessKey
    that.secretAccessKey=ossConfig.SecretKey
    that.endpoint=ossConfig.Endpoint

    that.credentials={
      accessKeyId: that.accessKeyId,
      secretAccessKey: that.secretAccessKey,
    }

    let config = {
      credentials: that.credentials,
      endpoint: that.endpoint,
      // httpOptions: { timeout: 50000 }, // 设置超时时间，默认120000，单位毫秒
      // maxRetries: 3,   // 设置请求重试次数
      // signatureVersion: "v4", // 设置签名类型，js预签名默认是v2
    };
    that.s3Client = new AWS.S3(config);
  }

  static getOssConfig(callback){
    const that=this;
    if(S3Config){
      callback(S3Config)
    }else {
      Http.get("/oss/index/getOssObj",{},res=>{
        if(res.code){
          S3Config=res.data;
          typeof callback==='function'&&callback(res.data)
        }
      });
    }
  }

  static isOssConfig(){
    return S3Config;
  }

  setBucket(bucket){
    this.bucket=bucket;
    return this;
  }
  setKey(key){
    this.key=key
    return this;
  }

  /**
   * 上传对象
   * @param callBack
   * @param params {
   *               Bucket: "<your-bucket-name>",
   *               Key: "<your-key-name>",
   *               Body: "",//文件
   *               ACL: "private", // 初始化acl权限，默认为private，"private"|"public-read"|"public-read-write"
   *               ContentType: "application/octet-stream", // 设置contentType, 默认是application/octet-stream
   *   }
   */
  putObject(callBack,params={}){
    const that=this;
    !params.Bucket&&(params.Bucket=this.bucket);
    !params.Key&&(params.Key=this.key);
    let loadingInstance = Loading.service({ fullscreen: true });
    this.s3Client.putObject(params, function(err, data) {
      loadingInstance.close();
      if (err){
        console.log(err, err.stack);
        // typeof callBack==="function"&&callBack({code:0,err:err})
        LogController.error({
          Bucket:params.Bucket,
          Key:params.Key,
          err:err,
          timeStr:(new Date()).getTime(),
          dateTime:moment().format(),
        },'oss','putObject')
        window.alert("文件上传对象存储失败");

      }else {
        // typeof callBack==="function"&&callBack(data)
        Http.post("/oss/index/addFile",{
          endpoint:that.endpoint,
          bucket:params.Bucket,
          path:params.Key,
        },function (ret) {
          if(ret.code){
            typeof callBack==="function"&&callBack(ret.data)
          }else {
            // typeof callBack==="function"&&callBack({code:0})
            console.log("文件上传失败[oss请求失败]");
            LogController.error("文件上传失败[oss请求失败]",'oss','putObject')
            window.alert("文件上传失败[oss请求失败]");
          }
        })
      }
    });
  }

  /**
   * 提交文件
   * @param file_path
   * @param file_name
   * @param callBack
   */
  upload(file_path,file_name,callBack){
    const that=this;
    that.putObject(callBack,{Body:file_path,Key:file_name})
  }

  /**
   * 提交多文件
   * @param file_paths
   * @param callBack
   */
  uploads(file_paths,callBack){
    const that=this;
    let call_list=[]
    file_paths.map((file,index)=>{
      that.upload(file,file.name,ret=>call_list.push(ret))
      if(index===(file_paths.length-1)){
        typeof callBack==="function"&&callBack(call_list)
      }
    })
  }

  /**
   * 带选择文件上传
   * @param callback
   */
  uploadFiles(callback){
    const that=this;
    let upload=document.getElementById("uploadFile-9999");
    if(!upload){
      upload=document.createElement('input');
      upload.type="file";
      upload.id="uploadFile-9999";
      upload.style.display="none";
    }
    upload.click();
    upload.onchange=function (e) {
      let formData = new FormData();
      let path=that._getBasePath();
      this.files=this.files.map(re=>{
        re.name=path+re.name;
        return re;
      })
      that.uploads(this.files,callback)
      upload.onchange=undefined;
    }
  }

  /**
   * 带选择文件单文件上传
   * @param callback
   */
  uploadFile(callback){
    const that=this;
    let upload=document.getElementById("uploadFile-9999");
    if(!upload){
      upload=document.createElement('input');
      upload.type="file";
      upload.id="uploadFile-9999";
      upload.style.display="none";
    }
    upload.click();
    upload.onchange=function (e) {
      let formData = new FormData();
      let path=that._getBasePath();
      let file_name=this.files[0].name;
      let file_name_arr=file_name.split('.');
      file_name_arr[file_name_arr.length-2]=file_name_arr[file_name_arr.length-2]+"_"+(new Date()).getTime().toString()
      let file_name_str=file_name_arr.join('.');
      that.upload(this.files[0],path+file_name_str,callback)
      upload.onchange=undefined;
    }
  }

  /**
   * 列举对象
   * @param callBack
   * @param params {
   *     Bucket: "<your-bucket-name>",
   * }
   */
  listObjects(callBack,params={}){
    !params.Bucket&&(params.Bucket=this.bucket);
    this.s3Client.listObjects(params, function(err, data) {
      if (err){
        console.log(err, err.stack);
        typeof callBack==="function"&&callBack(err)
      }else {
        console.log(data);
        typeof callBack==="function"&&callBack(data)
      }
    });
  }

  /**
   * 获取对象
   * @param callBack
   * @param params {
   *     Bucket: "<your-bucket-name>",
   *     Key: "<your-key-name>",
   * }
   */
  getObject(callBack,params={}){
    !params.Bucket&&(params.Bucket=this.bucket);
    !params.Key&&(params.Key=this.key);
    let loadingInstance = Loading.service({ fullscreen: true });
    this.s3Client.getObject(params, function(err, data) {
      loadingInstance.close();
      if (err){
        console.log(err, err.stack);
        LogController.error({
          Bucket:params.Bucket,
          Key:params.Key,
          err:err,
          timeStr:(new Date()).getTime(),
          dateTime:moment().format(),
        },'oss','getObject')
        typeof callBack==="function"&&callBack(err)
      }else {
        console.log(data);
        typeof callBack==="function"&&callBack(data)
      }
    });
  }

  /**
   * 获取临时签名文件(限时文件)
   * @param callBack
   * @param params
   * @returns {*}
   */
  getSignedUrl(callBack,params={}){
    !params.Bucket&&(params.Bucket=this.bucket);
    !params.Key&&(params.Key=this.key);
    !params.Expires&&(params.Expires=10*60);
    return this.s3Client.getSignedUrl('getObject',params);
  }

  /**
   * 获取Blob
   * @param callBack
   * @param params
   */
  getBlob(callBack,params={}){
    const that=this;
    that.getObject(ret=>{
      if(!ret.stack){
        let blob=new Blob([ret.Body],{type:ret.ContentType})
        typeof callBack==="function"&&callBack(blob)
      }
    },params)
  }

  /**
   * 获取url
   * @param callBack
   * @param params
   */
  getBlobUrl(callBack,params={}){
    const that=this;
    that.getBlob(blob=>{
      let url=URL.createObjectURL(blob)
      typeof callBack==="function"&&callBack(url)
    },params)
  }

  /**
   * 同步获取url
   * @param params
   * @returns {*}
   */
  getBlobUrlSyc(params={}){
    const that=this;
    return new Promise((resolve,reject)=>{
      that.getBlobUrl(url=>{
        resolve(url)
      },params)
    })
  }

  /**
   * 下载文件
   * @param callBack
   * @param params
   */
  download(callBack,params={}) {
    const that=this;
    that.getBlobUrl(url=>{
      let a;
      a = document.createElement('a');
      a.href = url;
      a.download = that.key;
      document.body.appendChild(a);
      a.style = 'display: none';
      typeof callBack==="function"&&callBack(a,url)
      a.click();
      a.remove();
    },params)
  }

  /**
   * 下载文件（可自定义下载文件名）
   * @param callBack
   * @param file_name
   */
  download2(file_name,callBack) {
    const that=this;
    that.getBlobUrl(url=>{
      let a;
      a = document.createElement('a');
      a.href = url;
      a.download = file_name;
      document.body.appendChild(a);
      a.style = 'display: none';
      typeof callBack==="function"&&callBack(a,url)
      a.click();
      a.remove();
    },{})
  }

  /**
   * 转临时文件下载
   * @param params
   */
  download3(params) {
    const that=this;
    let url=that.getSignedUrl(params);
    window.open(url);
  }



  /**
   * 删除对象
   * @param callBack
   * @param params {
   *     Bucket: "<your-bucket-name>",
   *     Key: "<your-key-name>",
   * }
   */
  deleteObject(callBack,params={}){
    !params.Bucket&&(params.Bucket=this.bucket);
    !params.Key&&(params.Key=this.key);
    this.s3Client.deleteObject(params, function(err, data) {
      if (err){
        console.log(err, err.stack);
        typeof callBack==="function"&&callBack(err)
      }else {
        console.log(data);
        typeof callBack==="function"&&callBack(data)
      }
    });
  }

  /**
   * 获取对象访问权限
   * @param callBack
   * @param params {
   *     Bucket: "<your-bucket-name>",
   *     Key: "<your-key-name>",
   * }
   */
  getObjectAcl(callBack,params={}){
    !params.Bucket&&(params.Bucket=this.bucket);
    !params.Key&&(params.Key=this.key);
    this.s3Client.getObjectAcl(params, function(err, data) {
      if (err){
        console.log(err, err.stack);
        typeof callBack==="function"&&callBack(err)
      }else {
        console.log(data);
        typeof callBack==="function"&&callBack(data)
      }
    });
  }

  multiPartUpload(file,callBack,progress){
    const that=this;
    console.log("multiPartUpload")
    // let key = "ExampleObject.txt"
    let upload = new AWS.S3.ManagedUpload({
      service: that.s3Client,
      partSize: 10 * 1024 * 1024, // 10M一片，可以根据需要自己定义，每个文件不能超过10000分片
      params: {
        Bucket: this.bucket,
        Key: that.key,
        Body: file,
        ACL: "private", // 初始化acl权限，默认为private，"private"|"public-read"|"public-read-write"
        ContentType: "text/plain", // 设置contentType, 默认是application/octet-stream
      },
    });

    upload.on("httpUploadProgress", _progress => progress(_progress))
    upload.send((err, data) => {
      if (err){
        console.log(err, err.stack);
        typeof callBack==="function"&&callBack(err)
      }else {
        console.log(data);
        typeof callBack==="function"&&callBack(data)
      }
    });
  }

  getUrl(callBack,params={}){
    const that=this;
    !params.Bucket&&(params.Bucket=this.bucket);
    !params.Key&&(params.Key=this.key);
    Http.get("/oss/index/getUrl",{
      endpoint:that.endpoint,
      bucket:params.Bucket,
      path:params.Key,
    },function (ret) {
      if(ret.code){
        typeof callBack==="function"&&callBack(ret.data)
      }
    })
  }

  RandomString(e=32) {
    let t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
    let a = t.length;
    let n = "";
    for (let i = 0; i < e; i++)
      n += t.charAt(Math.floor(Math.random() * a));
    return n
  }

  _getBasePath(){
    let y=moment(new Date()).format("YYYY");
    let m=moment(new Date()).format("MM");
    let d=moment(new Date()).format("DD");
    return `${y}/${m}/${d}/`;
  }

  getXscFile(fileId,callBack){
    Http.get("/oss/index/getXscFile",{
      fileId:fileId,
    },function (ret) {
      console.log(ret)
      if(ret.code){
        typeof callBack==="function"&&callBack(ret.data)
      }
    })
  }

  setXscFile(file_name,path,callBack){
    Http.post("/oss/SystemFile/addFile",{
      file_name:file_name,
      url:path
    },function (ret) {
      console.log(ret)
      if(ret.code){
        typeof callBack==="function"&&callBack(ret.data)
      }
    })
  }

  setXscFile2(file_name,path,file_id,callBack){
    Http.post("/oss/SystemFile/addFile",{
      file_name:file_name,
      url:path,
      file_id:file_id
    },function (ret) {
      console.log(ret)
      if(ret.code){
        typeof callBack==="function"&&callBack(ret.data)
      }
    })
  }

  fileToUpload(file,callback){
    let path=this._getBasePath();
    let file_name=file.name;
    let file_name_arr=file_name.split('.');
    file_name_arr[file_name_arr.length-2]=file_name_arr[file_name_arr.length-2]+"_"+(new Date()).getTime().toString()
    let file_name_str=file_name_arr.join('.');
    this.upload(file,path+file_name_str,callback)
  }
}



// WEBPACK FOOTER //
// ./src/common/ObjectStorage.js